<template>
    <div class="content-wrapper">
        <div class="d-flex align-items-center justify-content-between">
            <app-breadcrumb :page-title="$t('client_statement')"/>
            <div class="mb-4">
                <button type="button"
                        v-if="isAppAdmin"
                        class="btn btn-primary btn-with-shadow"
                        @click="exportAllClientStatement">
                    <app-icon name="download" class="size-20 mr-2"/>
                    {{ $t('export_all') }}
                </button>
            </div>
        </div>

        <app-table :id="tableId" :options="options"/>
    </div>
</template>

<script>
import ClientStatementMixin from '../../../Mixins/ClientStatementMixin';
import {urlGenerator} from "../../../Helpers/AxiosHelper";

export default {
    name: 'ClientStatementReport',
    mixins: [ClientStatementMixin],
    data() {
        return {
            isAppAdmin: false
        }
    },
    methods: {
        exportAllClientStatement() {
            window.location.replace(urlGenerator('reports/export-client-statement-report'))
        },
        checkIsAppAdmin() {
            let admin = JSON.parse(window.localStorage.permissions)
            this.isAppAdmin = admin.is_app_admin
        }
    },
    mounted() {
        this.checkIsAppAdmin();
    }
}
</script>